import { useState } from "react";
import { ConstraintEmployee } from "../../types/ganttChart";
import EmployeeConstraintContent from "./EmployeeConstraintContent";
import ConstraintListItemTitle from "./ConstraintListItemTitle";

const EmployeeListItem = ({
  employee,
  showActiveOnly,
}: {
  employee: ConstraintEmployee;
  showActiveOnly: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const title = employee.initials
    ? `${employee.name} (${employee.initials})`
    : employee.name;

  return (
    <div>
      <ConstraintListItemTitle
        title={title}
        isOpen={isOpen}
        onToggle={() => setIsOpen(!isOpen)}
      />
      {isOpen && (
        <EmployeeConstraintContent
          employeeRef={employee.employeeRef}
          constraints={employee.constraints}
          showActiveOnly={showActiveOnly}
        />
      )}
    </div>
  );
};

export default EmployeeListItem;
